import { DungChungService } from './../../../dung-chung/__services/dung-chung.service';
import {Component,
		OnInit,
		ViewChild,
		ChangeDetectionStrategy,
		ChangeDetectorRef,
		Inject,
		ViewRef,
		HostListener
	}
from '@angular/core';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import moment from 'moment';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatOptionSelectionChange } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { ThongTinHangVeService } from '../phieu-thong-tin-hang-ve-service-page/phieu-thong-tin-hang-ve.service';
//Model
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { DeNghiNhapKhoChiTiet, FileDinhKem, DeNghiNhapKho, KeHoachHangVe, FileImport, DSFileImport, DenghinhapkhoLsthaotac } from '../phieu-thong-tin-hang-ve-model-page/phieu-thong-tin-hang-ve.model';
//Component
import { KeHoachHangVeListPageDialogComponent } from '../ke-hoach-hang-ve-list-page-dialog/ke-hoach-hang-ve-list-page-dialog.component'
import { TimKiemNangCaoListComponent } from '../../../../tim-kiem-nang-cao/tim-kiem-nang-cao.component';
import { HangXuLyListPageDialogComponent } from '../hang-xu-ly-list-page-dialog/hang-xu-ly-list-page-dialog.component';
import { ThongTinDuyetDialogComponent } from '../thong-tin-duyet-detail-dialog/thong-tin-duyet-detail-dialog.component';
import { PBPassHangDialogComponent } from '../pb-pass-hang-dialog/pb-pass-hang-dialog.component';

@Component({
	selector: 'm-phieu-thong-tin-hang-ve-detail-dialog',
	templateUrl: './phieu-thong-tin-hang-ve-detail-dialog.component.html',
	styleUrls: ['../phieu-thong-tin-hang-ve-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class ThongTinHangVeDetailDialogCloneComponent implements OnInit {

	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/

	/*--------------------Comment columns mat-table----------------------*/
	displayedColumns = [];
	availableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongkehoach',
            displayName: 'SL kế hoạch',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoLuongThucNhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'Soluongchungtu',
            displayName: 'SL chứng từ',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SoLuongThucGiao',
            displayName: 'SL thực giao',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'Warning',
            displayName: 'Cảnh báo SL KH & TG',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'SLTangGiam',
            displayName: 'SL tăng/giảm',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 13,
            name: 'MaSub',
            displayName: 'Mã sub lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'Nguoinhanhang',
            displayName: 'Người nhận hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 15,
            name: 'TenPBKiemTra',
            displayName: 'Phòng ban kiểm tra',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 16,
            name: 'Ghichulohang',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
		},
		{
			stt: 17,
			name: 'TrangThaiPassHang',
			displayName: 'Trạng thái pass hàng',
			alwaysChecked: false,
			isShow: true
		},
        // {
        //     stt: 99,
        //     name: 'actions',
        //     displayName: 'Thao tác',
		// 	alwaysChecked: true,
		// 	isShow: true
        // }
	];
	KHTraColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongkehoach',
            displayName: 'SL kế hoạch',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoLuongThucNhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'Soluongchungtu',
            displayName: 'SL chứng từ',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SoLuongThucGiao',
            displayName: 'SL thực giao',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'Warning',
            displayName: 'Cảnh báo SL KH & TG',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'SLTangGiam',
            displayName: 'SL tăng/giảm',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'SoPhieuDHB',
            displayName: 'Số phiếu ĐHB',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'TenKhachHang',
            displayName: 'Khách hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 15,
            name: 'MaSub',
            displayName: 'Mã sub lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 16,
            name: 'Nguoinhanhang',
            displayName: 'Người nhận hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 17,
            name: 'TenPBKiemTra',
            displayName: 'Phòng ban kiểm tra',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 18,
            name: 'Ghichulohang',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
		},
		{
			stt: 18,
			name: 'TrangThaiPassHang',
			displayName: 'Trạng thái pass hàng',
			alwaysChecked: false,
			isShow: true
		},
        // {
        //     stt: 99,
        //     name: 'actions',
        //     displayName: 'Thao tác',
		// 	alwaysChecked: true,
		// 	isShow: true
        // }
	];
	NCCGiaoColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongkehoach',
            displayName: 'SL kế hoạch',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoLuongThucNhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'Soluongchungtu',
            displayName: 'SL chứng từ',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SoLuongThucGiao',
            displayName: 'SL thực giao',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'Warning',
            displayName: 'Cảnh báo SL KH & TG',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'SLTangGiam',
            displayName: 'SL tăng/giảm',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'SoPhieuDNMH',
            displayName: 'Số phiếu ĐNMH',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 13,
            name: 'SoPhieuDH',
            displayName: 'Số phiếu ĐHM',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'TenNCC',
            displayName: 'Nhà cung cấp',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 15,
            name: 'MaSub',
            displayName: 'Mã sub lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 16,
            name: 'Nguoinhanhang',
            displayName: 'Người nhận hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 17,
            name: 'TenPBKiemTra',
            displayName: 'Phòng ban kiểm tra',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 18,
            name: 'Ghichulohang',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
		},
		{
			stt: 19,
			name: 'TrangThaiPassHang',
			displayName: 'Trạng thái pass hàng',
			alwaysChecked: false,
			isShow: true
		},
        // {
        //     stt: 99,
        //     name: 'actions',
        //     displayName: 'Thao tác',
		// 	alwaysChecked: true,
		// 	isShow: true
        // }
	];
	HangXuLyColumn = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongkehoach',
            displayName: 'SL kế hoạch',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoLuongThucNhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'Soluongchungtu',
            displayName: 'SL chứng từ',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SoLuongThucGiao',
            displayName: 'SL thực giao',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'Warning',
            displayName: 'Cảnh báo SL KH & TG',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'SLTangGiam',
            displayName: 'SL tăng/giảm',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'SoPhieuKPH',
            displayName: 'Số phiếu KPH',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 13,
            name: 'MaSub',
            displayName: 'Mã sub lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'Nguoinhanhang',
            displayName: 'Người nhận hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 15,
            name: 'TenPBKiemTra',
            displayName: 'Phòng ban kiểm tra',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 16,
            name: 'Ghichulohang',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
		},
		{
			stt: 17,
			name: 'TrangThaiPassHang',
			displayName: 'Trạng thái pass hàng',
			alwaysChecked: false,
			isShow: true
		},
        // {
        //     stt: 99,
        //     name: 'actions',
        //     displayName: 'Thao tác',
		// 	alwaysChecked: true,
		// 	isShow: true
        // }
	];

	displayedFileTable = [];
	FileTableColumn = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
            stt: 2,
            name: 'FileName',
            displayName: 'Tên tệp',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 3,
            name: 'GhiChu',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
		},
	];
	/* ------------------------------------------------------------------*/

	/*------------------------ Danh sách trạng thái ----------------------*/
	listState : any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */


	/* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<DeNghiNhapKhoChiTiet>(true, []);

	selectedFileTableColumns = new SelectionModel<any>(true, this.FileTableColumn);
	selectionFileTable = new SelectionModel<FileDinhKem>(true, []);
	/* ------------------------------------------------------------------ */


	/* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */
	
	
	/* ------------------- Các form trên dialog --------------------------*/
	ThongTinHangVeForm: FormGroup;				
	/* ------------------------------------------------------------------ */


	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	thongTinHangVeItem: DeNghiNhapKho;

	listChiTietHangVe: DeNghiNhapKhoChiTiet[] = [];
	tmpChiTietHangVe: DeNghiNhapKhoChiTiet[] = [];
	returnListKeHoachHangVe: KeHoachHangVe[] = [];
	selected: any[] = [];
	selectedHXL: any[] = [];
	/* ------------------------------------------------------------------ */


	/* ----------------------- Xử lý File đính kèm -----------------------*/
	listFileName: string[] = [];
	listFileDinhKem: FileDinhKem[] = [];
	dataArray: FileImport[] = [];
	/* ------------------------------------------------------------------ */
	

	/*------------------------- Extend field: ----------------------------*/
	title: string = '';	
	fixedPoint = 2;                		 // Số chữ số phần thập phân cho kiểu dữ liệu số.	
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	saveAdded: number[] = []		// Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	listLoaiPhieu: any[];
	openTimKiemNangCao = false;
	flagChangeLoaiPhieu = -1;
	saveNewCT: number[] = [];
	disableButton: boolean = true;
	/* ------------------------------------------------------------------ */

	constructor(
		public dialogRef: MatDialogRef<ThongTinHangVeDetailDialogCloneComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private thongTinHangVeService: ThongTinHangVeService,
		private dungChungService : DungChungService,
		private ThongTinHangVeFB: FormBuilder,
		public dialog: MatDialog,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private subheaderService: SubheaderService,
		private activatedRoute: ActivatedRoute,
	) {}


	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit(){

		/*Load all dropdown and create form */
		this.ListState();

		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		
		this.listLoaiPhieu = DeNghiNhapKho.optionsLoaiPhieu;
		this.thongTinHangVeItem = new DeNghiNhapKho();
		this.thongTinHangVeItem.clear();
		this.thongTinHangVeItem = this.data.data;
		this.createForm();
		this.bindingValueAfterCallAPIDetail();

		/*Load title of dialog */
		this.title = this.getTitle();
		
		/* Display columns */
		this.checkDisplayColumnsBaseOnForm();
		this.showColumnsInTable();
		this.applySelectedColumns();
		this.applyFileTableColumns();
	}
	isCreate(){
		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		if(this.thongTinHangVeItem != null && (this.thongTinHangVeItem.Nguoitao == +idUser)){
			return true;
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/
	 

	/*----------------- Create Form and handle event on form-- ---------------*/
	createForm(){

		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		/*Group các Form */
		this.ThongTinHangVeForm = this.ThongTinHangVeFB.group({
			SoPhieu: ['', Validators.required],
			NgayLapPhieu: [new Date(), Validators.required],
			TenNguoiLap: [tenNguoiLap],
			TrangThai: [this.nameState],
			LoaiPhieu:['1']
		});

		/*Disable các trường dữ liệu không thay đổi */
		this.ThongTinHangVeForm.disable();
		/*------------------------------------------------------------------*/

		this.changeDetectView();
	}
	bindingValueAfterCallAPIDetail(){
		if(this.thongTinHangVeItem.IdDn > 0){

			this.ThongTinHangVeForm.controls["SoPhieu"].setValue(this.thongTinHangVeItem.Sophieu);
			this.ThongTinHangVeForm.controls["NgayLapPhieu"].setValue(this.thongTinHangVeItem.Ngaynhap);
			this.ThongTinHangVeForm.controls["TenNguoiLap"].setValue(this.thongTinHangVeItem.TenNguoitao);
			
			let item = DeNghiNhapKho.optionsLoaiPhieu.find( x => x.value == +this.thongTinHangVeItem.LoaiPhieu);
			this.ThongTinHangVeForm.controls["LoaiPhieu"].setValue(item.name);
			this.checkState();

			/*Add dữ liệu chi tiết */
			if(this.thongTinHangVeItem.listChiTietNhapKho != null && this.thongTinHangVeItem.listChiTietNhapKho.length > 0){
				var idUser = '';
				this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });

				this.listChiTietHangVe = this.thongTinHangVeItem.listChiTietNhapKho;
				this.tmpChiTietHangVe = [];
				for(let i = 0; i < this.listChiTietHangVe.length; i++){
					let tmpElement = new DeNghiNhapKhoChiTiet();
					tmpElement.copy(this.listChiTietHangVe[i])
					if(tmpElement.Nguoinhanhang == 0){
						tmpElement.Nguoinhanhang = +idUser
					}
					this.tmpChiTietHangVe.push(tmpElement);
				}
			
				this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];

				if(this.thongTinHangVeItem.listFileDinhKem != null
					&& this.thongTinHangVeItem.listFileDinhKem.length >0){
						this.listFileDinhKem = this.thongTinHangVeItem.listFileDinhKem;
						this.listFileDinhKem = [...this.listFileDinhKem];
				}
				this.changeDetectView();
			}
		}
	}
	getTitle(): string {
		return 'Chi tiết phiếu TTHV';
	}
	getTrangThaiDetail(state: string){
		let item = DeNghiNhapKhoChiTiet.optionTrangThaiDetail.find(x => x.value == state)
		if(item != null){
			return item.name;
		}
		return '';
	}
	checkWarningState(item: DeNghiNhapKhoChiTiet){
		var tmp = Number(item.Soluongkehoach) * item.DungSai / 100;
		var result = -1;

		if(Number(item.SoLuongThucGiao) > Number(item.Soluongkehoach) + tmp){
			result = 0;
		}
		if((Number(item.Soluongkehoach) - tmp) <= Number(item.SoLuongThucGiao)
		&& (Number(item.SoLuongThucGiao) <= Number(item.Soluongkehoach) + tmp)){
			result = 1;
		}
		if(Number(item.SoLuongThucGiao) < Number(item.Soluongkehoach) - tmp){
			result = 2;
		}
		return result;
	}
	warningState(item: DeNghiNhapKhoChiTiet ){
		let result = this.checkWarningState(item);
		switch(result){
			case 0:
				return '> dung sai cho phép';
			case 1:
				return 'Thuộc dung sai cho phép';
			case 2:
				return '< dung sai cho phép';
			default:
				return ''
		}
	}
	cssWarningState(item:DeNghiNhapKhoChiTiet){
		let result = this.checkWarningState(item);
		switch(result){
			case 0:
				return 'red';
			case 1:
				return 'green';
			case 2:
				return 'orange';
			default:
				return ''
		}
	}
	holdValueLoaiPhieuBeforeChange(){
		this.ThongTinHangVeForm.controls['LoaiPhieu'].setValue(this.flagChangeLoaiPhieu.toString());
		this.changeDetectView();
	}
	checkChangeLoaiPhieu(value: any){
		if(this.tmpChiTietHangVe.length == 0){
			this.ThongTinHangVeForm.controls['LoaiPhieu'].setValue(value.toString())
			this.flagChangeLoaiPhieu = +this.ThongTinHangVeForm.controls['LoaiPhieu'].value
			this.acceptChangeLoaiPhieu();
		}
		else if(value != +this.ThongTinHangVeForm.controls['LoaiPhieu'].value){
			const dialogRef = this.layoutUtilsService.POPConfirm();
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					this.ThongTinHangVeForm.controls['LoaiPhieu'].setValue(this.flagChangeLoaiPhieu.toString())
					return;
				}
				this.ThongTinHangVeForm.controls['LoaiPhieu'].setValue(value.toString())
				this.flagChangeLoaiPhieu = +this.ThongTinHangVeForm.controls['LoaiPhieu'].value
				this.acceptChangeLoaiPhieu();
			});
		}
	}
	acceptChangeLoaiPhieu(){
		this.listChiTietHangVe = [];
		this.tmpChiTietHangVe = [];
		this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];
		
		this.selected = [];
		this.selectedHXL = [];

		this.checkDisplayColumnsBaseOnForm();
		this.applySelectedColumns();
		this.changeDetectView();

	}
	checkIsChange(item: DeNghiNhapKhoChiTiet){
		let index = this.tmpChiTietHangVe.findIndex(x => x.IdCtdn == item.IdCtdn);
		if(index > -1){
			let itemTmp = Number(this.tmpChiTietHangVe[index].SoLuongThucGiao);
			let itemReal = Number(this.listChiTietHangVe[index].SoLuongThucGiao);
			if(itemTmp != 0 && itemTmp != itemReal){
				this.disableButton = false;
			}
			else{
				this.disableButton = true;
			}
		}
		else{
			this.disableButton = true;
		}
		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/
	

	/*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
	showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	applyFileTableColumns() {
		let _selectedColumns = this.selectedFileTableColumns.selected;
		this.selectedFileTableColumns = new SelectionModel<any>(true, this.FileTableColumn);
		for(let i = 0; i < this.FileTableColumn.length; i++){
			this.selectedFileTableColumns.toggle(this.FileTableColumn[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.FileTableColumn[i].name == _selectedColumns[j].name){
					this.selectedFileTableColumns.toggle(this.FileTableColumn[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedFileTableColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedFileTable = _applySelectedColumns;
	}
	checkDisplayColumnsBaseOnForm(){
		if(+this.ThongTinHangVeForm.controls['LoaiPhieu'].value == DeNghiNhapKho.optionsLoaiPhieu[0].value){
			this.availableColumns = this.KHTraColumns
		}
		else if(+this.ThongTinHangVeForm.controls['LoaiPhieu'].value ==  DeNghiNhapKho.optionsLoaiPhieu[1].value){
			this.availableColumns = this.NCCGiaoColumns
		}
		else if(+this.ThongTinHangVeForm.controls['LoaiPhieu'].value == DeNghiNhapKho.optionsLoaiPhieu[2].value){
			this.availableColumns = this.HangXuLyColumn
		}
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/
	

	/*------------------------- Hàm lấy danh sách-----------------------------*/
	ListState(){
		this.dungChungService.listState(DeNghiNhapKho.category_path).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetectView();
			};
		});
	}
	checkState(){
		this.listState.forEach(element => {
			if(element.Code == this.thongTinHangVeItem.Tinhtrang){
				this.nameState = element.Description;
				if(this.ThongTinHangVeForm != null)
					this.ThongTinHangVeForm.controls["TrangThai"].setValue(this.nameState);
			}
		});
	}
	/* -----------------------------------------------------------------------*/


	/*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
	showErrorInputSL(columnName: string, formGroup: any, name: string){
		let message = "";
		let controls = formGroup.controls;
		if(controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
		if(controls[columnName].hasError('maxlength') 
			|| (controls[columnName].value.length > 22 
				&& (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21))) 
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == ','){
					count += 1;
				}
			}
		}
		else{
			event = "" + event
			for(let i = 0; i < event.length; i++){
				if(event[i] == ','){
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string){
		if(number.indexOf(',') > 0){
			
		}
		let item = +number.replace(/\./g, "").replace(/,/g, ".");;
		return item
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return DeNghiNhapKhoChiTiet.DEFAULT_NUMBER_VALUE;
		return new Intl.NumberFormat('de-DE',{ style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}
	keyUpInputNumberVND(event){
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup){
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChangedV2(event);
			if(data){
				if(this.formatComparenumber(data) < min && event.data && event.data == '0') data = this.f_currency_VND(this.formatNumber(min.toString()));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

				if(data.length == 4){
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
				
			}else{
				controls[columnName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup){
		let controls = formGroup.controls;
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");
			
			if(Number(tmpValue) < min) tmpValue = min;

			if(!controls[controlName].invalid){
				controls[controlName].setValue(
					this.f_currency_VND(this.formatNumber(tmpValue))
				);
			}
			if(tmpValue.indexOf(',') == 0 && tmpValue.length == 1){
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_currency_VND(this.formatNumber(tmpValue))
			);
		}
		else{
			controls[controlName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
			//console.log(controls[controlName].value);
		}
	}
	changeInputNumberVNDInList(event : any, min: number = 0){
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChangedV2(event);
			if(data){
				if(this.formatComparenumber(data) < min && event.data && event.data == '0') data = this.f_currency_VND(this.formatNumber(min.toString()));
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
			}else{
				event.target.value = this.f_currency_VND(this.formatNumber(min.toString()));
			}
			
			//this.changeDetect.detectChanges();
		}
	}
	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: DeNghiNhapKhoChiTiet){
		
		if(event.target.value == "")
		{
			event.target.value =  this.f_number(0);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if(event.target.value.toString() == item[columnName].toString())
		{
			event.target.value =  this.f_number(item[columnName]);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");

			if(Number(tmpValue) < min) tmpValue = min;

			if(!item[columnName]){
				item[columnName] = tmpValue.toString();
			}

			if(tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1){
				tmpValue = min;
			}
			item[columnName] =tmpValue.toString();
		}
		else{
			item[columnName] = min.toString();
		}

		this.changeDetectView();
	}
	calculateSoLuongTangGiam(item: any){
		var value = Number(item.SoLuongThucGiao) - Number(item.Soluongkehoach);
		value = Number(value.toFixed(this.fixedPoint));
		if(value < 0)
			return this.f_number(value)
		return "+" + this.f_number(value)
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
	getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	/* -----------------------------------------------------------------------*/


	/*---------------------------- Thao tác trên form ------------------------*/
	back(){
		this.dialogRef.close();
	}
	checkStateUpdateSL(){
		if(this.thongTinHangVeItem.Tinhtrang == DeNghiNhapKho.optionsTinhTrang[1].value ||
			this.thongTinHangVeItem.Tinhtrang == DeNghiNhapKho.optionsTinhTrang[2].value)
			return true;
		return false;
	}
	thongTinDuyet(item: DeNghiNhapKhoChiTiet, ls: DenghinhapkhoLsthaotac[]) {
		const dialogRef = this.dialog.open(ThongTinDuyetDialogComponent, {
			data: { 
				data: item,
				ls: ls
			},
			width: '60vw'
		});

		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
			else {
				if (!res.isChange) {
					return;
				}
				this.thongTinHangVeService.getDetail(this.thongTinHangVeItem).subscribe(res => {
					this.thongTinHangVeItem.listChiTietNhapKho = res.data.listChiTietNhapKho
					this.bindingValueAfterCallAPIDetail();
				});
			}
		});
	}
	checkPhieuDeNghiMuaHangKoCheckKT(item: DeNghiNhapKhoChiTiet, ls: DenghinhapkhoLsthaotac[]) {
		const dialogRef = this.dialog.open(PBPassHangDialogComponent, {
			data: { 
				data: item,
				isDetail: true,
				ls: ls
			},
			width: '60vw'
		});

		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
			else {
				if (!res.isChange) {
					return;
				}
				this.thongTinHangVeService.getDetail(this.thongTinHangVeItem).subscribe(res => {
					this.thongTinHangVeItem.listChiTietNhapKho = res.data.listChiTietNhapKho
					this.bindingValueAfterCallAPIDetail();
				});
			}
		});
	}
	xuLy(item: DeNghiNhapKhoChiTiet) {
		if(item.CanPhieuKT){
			this.thongTinDuyet(item, this.thongTinHangVeItem.listDenghinhapkhoLsthaotac);
		}
		else{
			this.checkPhieuDeNghiMuaHangKoCheckKT(item,  this.thongTinHangVeItem.listDenghinhapkhoLsthaotac);
		}
	}
	updateSL() {
		const dialogRef = this.layoutUtilsService.POP02('');

		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}
			
			this.thongTinHangVeService.updateSLDetail(this.tmpChiTietHangVe).subscribe(res => {
				if (res.status == 1) {
					const message = `Cập nhật số lượng thực giao thành công`;
					this.layoutUtilsService.showInfo(message);
	
					var idUser = '';
					this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
	
					this.listChiTietHangVe = this.tmpChiTietHangVe;
					this.tmpChiTietHangVe = [];
					for(let i = 0; i < this.listChiTietHangVe.length; i++){
						let tmpElement = new DeNghiNhapKhoChiTiet();
						tmpElement.copy(this.listChiTietHangVe[i])
						if(tmpElement.Nguoinhanhang == 0){
							tmpElement.Nguoinhanhang = +idUser
						}
						this.tmpChiTietHangVe.push(tmpElement);
					}
				
					this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];
					this.disableButton = true;
					
					this.changeDetectView();
				}
				else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
			});
		})
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------------ Extend Options --------------------------*/
	scrollToBottom(){
		setTimeout(() => {
			// let height = document.getElementById('dialog-form').scrollHeight
			// document.getElementById('dialog-form').scrollTo({ top: height, behavior: 'smooth' });
			window.scrollTo({top: document.body.scrollHeight, behavior: 'smooth' });
		}, 300);
	}
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
        if (event.key == "Escape") {
			//this.back();
		}
		this.changeDetectView();
	}
	highlightNewestRecord(currentPosition: number) {
		if (this.saveNewCT.findIndex(x => x == currentPosition) > -1) {
			return true;
		}
		return false;
	}
	downloadFile(idFile: number) {
		let linkdownload = this.thongTinHangVeService.downloadTemplate(idFile);
		window.open(linkdownload);
	}
	/* -----------------------------------------------------------------------*/
}
